<template lang="pug">
.text-start
  .text.mt-4 Após salvar o hash do termo digital, faça a conversão de hexa para binário:
  .h6.mt-4 #[strong Linux / MacOS]:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='conversionLinuxMac') $ xxd -r -p
        = ' '
        span.red-background.color--grayscale-dark digitalterm_hash.hex
        = ' '
        span.red-background.color--grayscale-dark digitalterm_hash.bin
    Icon#copy-conversion-linux-mac.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.conversionLinuxMac, 1)',
      @mouseleave='resetContent(1)',
      style='cursor: pointer'
    )
  .h6.mt-4 #[strong Windows]:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='conversionWindows') $ hex-to-bin.ps1
    Icon#copy-conversion-windows.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.conversionWindows, 2)',
      @mouseleave='resetContent(2)',
      style='cursor: pointer'
    )
  .text.mt-4 Faça a assinatura digital:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='digitalSignature') $ openssl rsautl -sign -in
        = ' '
        span.red-background.color--grayscale-dark digitalterm_hash.bin
        = ' '
        | -inkey
        = ' '
        span.red-background.color--grayscale-dark cert1.key
        = ' '
        | -out
        = ' '
        span.red-background.color--grayscale-dark signature.bin
    Icon#copy-digital-signature.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.digitalSignature, 3)',
      @mouseleave='resetContent(3)',
      style='cursor: pointer'
    )
  .code-box.mt-3
    .text Enter pass phrase for cert1.key:
      = ' '
      span.red-background #{ '<senha de proteção da chave privada>' }
  .text.mt-4 Converta para Base64:
  .h6.mt-4 #[strong Linux]:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='convertBase64Linux') $ base64 -w 64 -i
        = ' '
        span.red-background.color--grayscale-dark signature.bin
    Icon#copy-conversion-linux.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.convertBase64Linux, 4)',
      @mouseleave='resetContent(4)',
      style='cursor: pointer'
    )
  .h6.mt-4 #[strong MacOS]:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='convertBase64Mac') $ base64 -b 64 -i
        = ' '
        span.red-background.color--grayscale-dark signature.bin
    Icon#copy-conversion-mac.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.convertBase64Mac, 5)',
      @mouseleave='resetContent(5)',
      style='cursor: pointer'
    )
  .h6.mt-4 #[strong Windows]:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='convertBase64Windows') $ base64.ps1
    Icon#copy-conversion-windows-base64.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.convertBase64Windows, 6)',
      @mouseleave='resetContent(6)',
      style='cursor: pointer'
    )
  .alert.alert-dismissible.alert-success.mt-4(role='alert')
    .alert__icon
      Icon(name='circle-check')
    .alert__content
      .text O resultado dessa conversão deve ser informado no campo
        |#[strong Assinatura do Termo Digital].
  .h6.mt-4 #[strong Se desejar, pode verificar a assinatura digital do termo]:
  .text.mt-4 Primeiro exporte a chave pública a partir da chave privada:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='exportKey') $ openssl rsa -in
        = ' '
        span.red-background.color--grayscale-dark cert1.key
        = ' '
        | -pubout -out
        = ' '
        span.red-background.color--grayscale-dark cert1.pub
    Icon#copy-export-key.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.exportKey, 7)',
      @mouseleave='resetContent(7)',
      style='cursor: pointer'
    )
  .code-box.mt-3
    .text Enter pass phrase for cert1.key:
      = ' '
      span.red-background #{ '<senha de proteção da chave privada>' }
      |
      | writing RSA key
  .text.mt-4 E depois execute a verificação:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='runTheCheck') $ openssl pkeyutl -verify -in
        = ' '
        span.red-background.color--grayscale-dark digitalterm_hash.bin
        = ' '
        | -pubin -inkey
        = ' '
        span.red-background.color--grayscale-dark cert1.pub
        = ' '
        | -sigfile
        = ' '
        span.red-background.color--grayscale-dark signature.bin
    Icon#copy-run-the-check.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.runTheCheck, 8)',
      @mouseleave='resetContent(8)',
      style='cursor: pointer'
    )
  .code-box.mt-3
    .text Signature Verified Successfully
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { Tooltip } from 'bootstrap'

  type TooltipType = {
    id: number
    tooltip: Tooltip
  }

  export default defineComponent({
    name: 'GenerateCSRRequestView',
    components: {
      Icon,
    },
    data() {
      return {
        tooltips: [] as TooltipType[],
      }
    },
    mounted() {
      this.tooltips.push({
        id: 1,
        tooltip: new Tooltip('#copy-conversion-linux-mac', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 2,
        tooltip: new Tooltip('#copy-conversion-windows', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 3,
        tooltip: new Tooltip('#copy-digital-signature', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 4,
        tooltip: new Tooltip('#copy-conversion-linux', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 5,
        tooltip: new Tooltip('#copy-conversion-mac', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 6,
        tooltip: new Tooltip('#copy-conversion-windows-base64', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 7,
        tooltip: new Tooltip('#copy-export-key', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 8,
        tooltip: new Tooltip('#copy-run-the-check', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })
    },
    methods: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async doCopy(ref: any, id: number) {
        await navigator.clipboard.writeText(ref.textContent.replace('$ ', ''))
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Código copiado!' })
      },
      resetContent(id: number) {
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Clique para copiar' })
      },
    },
  })
</script>
